import React from 'react';
import bio from '../../../img/product/bio.svg';
import { Tag, Space, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

export const BiologicalLegend = ({ height = 18 }) => (
  <img src={bio} alt={'biologique'} style={{ height: height }} />
);

export const ProductTypeLegend = ({ type, height = 18 }) => {
  const { t } = useTranslation('common');

  const legends = {
    serie: {
      text: t('product|legends.serie'),
      color: '#135200',
    },
    biological: {
      component: <BiologicalLegend height={height} />,
    },
  };

  const legend = legends[type];
  if (!legend) return null;

  if (legend.component) {
    return legend.component;
  }

  return (
    <Tag color={legend.color} className="rounded text-[11px]">
      {legend.text}
    </Tag>
  );
};

const ProductLegends = () => {
  const { t } = useTranslation('common');

  const legends = [
    {
      key: 'urgent',
      text: t('product|legends.urgent'),
      color: '#006D75',
      tooltip: t('product|legends.urgentTooltip'),
    },
    {
      key: 'pfi',
      text: t('product|legends.pfi'),
      color: '#1C8E4B',
      tooltip: t('product|legends.pfiTooltip'),
    },
    {
      key: 'serie',
      text: t('product|legends.serie'),
      color: '#135200',
      tooltip: t('product|legends.serieTooltip'),
    },
    {
      key: 'nouveau',
      text: t('product|legends.nouveau'),
      color: '#08979C',
      tooltip: t('product|legends.nouveauTooltip'),
    },
    {
      key: 'emballage',
      text: t('product|legends.emballage'),
      color: '#95DE64',
      tooltip: t('product|legends.emballageTooltip'),
    },
    {
      key: 'tolerance',
      text: t('product|legends.tolerance'),
      color: '#D48806',
      tooltip: t('product|legends.toleranceTooltip'),
    },
  ];

  return (
    <div className="flex gap-6 items-center flex-wrap">
      <p className="text-[#186845] underline font-bold">
        {t('product|legends.title')}
      </p>
      <Space wrap size="small">
        <Tooltip
          title={t('product|legends.biologicalApprovalTooltip')}
          placement="top"
        >
          <div className="flex h-[38px] px-[6px] py-1 flex-col justify-center items-center gap-2 rounded  cursor-help">
            <BiologicalLegend height={32} />
          </div>
        </Tooltip>
        {legends.map((legend) => (
          <Tooltip key={legend.key} title={legend.tooltip} placement="top">
            <Tag
              color={legend.color}
              className="rounded cursor-help text-[11px]"
            >
              {legend.text}
            </Tag>
          </Tooltip>
        ))}
      </Space>
    </div>
  );
};

export default ProductLegends;
